import {
  Component,
  Element,
  h,
  Host,
  State,
  ComponentInterface,
} from '@stencil/core';

@Component({
  tag: 'signet-header-item',
})
export class SignetHeaderItem implements ComponentInterface {
  @Element() $el: HTMLElement;

  @State() isActive: boolean;

  getActiveStatus() {
    const $link = this.$el.querySelector('a');

    const isActive = $link
      ? $link.getAttribute('href') === window.location.pathname
      : false;

    if (isActive) $link.setAttribute('aria-current', 'page');

    return isActive;
  }

  render() {
    const classes = {
      'header-item': true,
      active: this.getActiveStatus(),
    };

    return (
      <Host class={classes}>
        <slot />
      </Host>
    );
  }
}
